/**
 * @generated SignedSource<<c7eed37c977e818574a9ec99c717e042>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeroCarouselThumb_muxVideo$data = {
  readonly thumbnail: string | null;
  readonly " $fragmentType": "HeroCarouselThumb_muxVideo";
};
export type HeroCarouselThumb_muxVideo$key = {
  readonly " $data"?: HeroCarouselThumb_muxVideo$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselThumb_muxVideo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeroCarouselThumb_muxVideo",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "height",
          "value": 75
        },
        {
          "kind": "Literal",
          "name": "width",
          "value": 100
        }
      ],
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": "thumbnail(height:75,width:100)"
    }
  ],
  "type": "VideoV2",
  "abstractKey": null
};

(node as any).hash = "47248097b86bdfcc2e0fd0cb3ab0a50b";

export default node;
